document.addEventListener("DOMContentLoaded", function () {
  const wishlistButtons = document.querySelectorAll(".wt-button");
  const wishlistCountEl = document.getElementById("wishlist-header-count");
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  const isLoggedIn = window.isLoggedIn;

  // Defensive helper to safely read dataset or attribute
  function getAttr(el, name) {
    return el.dataset && el.dataset[name] ? el.dataset[name] : el.getAttribute('data-' + name.replace(/([A-Z])/g, "-$1").toLowerCase());
  }

  wishlistButtons.forEach(button => {
    const handle = getAttr(button, 'productHandle');     // expects data-product-handle
    const productTitle = getAttr(button, 'productTitle'); // expects data-product-title
    const productId = getAttr(button, 'productId') || handle;
    const productPrice = getAttr(button, 'productPrice');

    if (!handle || !productTitle) {
      console.warn('Wishlist button missing required data attributes:', { handle, productTitle, el: button });
    }

    if (wishlist.includes(handle)) {
      button.classList.add("active");
    }

    button.addEventListener("click", function (e) {
      e.preventDefault();

      const currentPath = window.location.pathname;
      if (!isLoggedIn && !currentPath.startsWith("/account")) {
        sessionStorage.setItem("redirect_after_login", window.location.href);
        window.location.href = "/account/register";
        return;
      }

      // Determine action: add or remove
      let action;
      if (!wishlist.includes(handle)) {
        wishlist.push(handle);
        showSuccessNotification("Added to Wishlist.");
        action = "wishlist_add";
      } else {
        wishlist = wishlist.filter(h => h !== handle);
        showSuccessNotification("Removed from Wishlist.");
        action = "wishlist_remove";
      }

      localStorage.setItem("wishlist", JSON.stringify(wishlist));
      this.classList.toggle("active");
      updateWishlistCount();

      // Build dataLayer object
      const dlObj = {
        event: action,
        ecommerce: {
          items: [
            {
              item_name: productTitle || "(not set)",
              item_id: productId || "(not set)",
              item_handle: handle || "(not set)",
              price: productPrice || "(not set)",
              currency: "INR"
            }
          ]
        },
        timestamp: new Date().toISOString()
      };

      // Always push to dataLayer (do not depend on Shopify.analytics availability)
      try {
        window.dataLayer = window.dataLayer || [];
        console.log("Pushing to dataLayer:", dlObj);
        window.dataLayer.push(dlObj);
      } catch (err) {
        console.error("dataLayer push error:", err);
      }

      // Optional: also publish to Shopify analytics if available (non-blocking)
      try {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish("custom_wishlist_click", {
            product_handle: handle,
            product_title: productTitle,
            action: action,
            timestamp: new Date().toISOString(),
          });
        }
      } catch (err) {
        console.error("Shopify analytics publish error:", err);
      }

      console.log(`Wishlist ${action} for:`, productTitle, handle);
    });
  });

  function updateWishlistCount() {
    if (!wishlistCountEl) return;
    if (wishlist.length > 0) {
      wishlistCountEl.textContent = wishlist.length;
      wishlistCountEl.style.display = "flex";
    } else {
      wishlistCountEl.textContent = "";
      wishlistCountEl.style.display = "none";
    }
  }

  function showSuccessNotification(message) {
    const existing = document.getElementById("success-notification");
    if (existing) existing.remove();

    const notification = document.createElement("div");
    notification.id = "success-notification";
    notification.className = "success-notification";
    notification.innerHTML = `
      <div class="success-msg">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9">
          <path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"/>
        </svg>
        <span>${message}</span>
      </div>
    `;
    document.body.appendChild(notification);
    setTimeout(() => {
      notification.style.opacity = '0';
      setTimeout(() => notification.remove(), 1000);
    }, 2000);
  }

  updateWishlistCount();
  console.log('%cCrafted by Rupz Web youtube.com/@rupz_web', 'color:#ff4d6d;font-weight:bold;font-size:13px');
});
